


import { createContext, useContext, useState, useEffect } from "react";
// import { v4 as uuidv4 } from "uuid";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const storedCart = localStorage.getItem("cart");
      return storedCart ? JSON.parse(storedCart) : [];
    } catch (error) {
      console.error("Error parsing cart from localStorage:", error);
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    const existingItem = cart.find((item) => item.productId === product._id);

    if (existingItem) {
      const updatedCart = cart.map((item) =>
        item.productId === product._id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      setCart(updatedCart);
    } else {
      // Determine item type:
      // - If type is already 'product' or 'embroidery-design', use it (set by caller)
      // - If product has selectedMachines, it's embroidery-design
      // - Otherwise default to 'product'
      let itemType = 'product';
      if (product.type === 'product' || product.type === 'embroidery-design') {
        itemType = product.type;
      } else if (product.selectedMachines && product.selectedMachines.length > 0) {
        itemType = 'embroidery-design';
      }
      
      setCart([
        ...cart,
        {
          ...product,
          productId: product._id,
          quantity: 1,
          images: product.images || [], // Ensure images are included
          type: itemType // Set correct type (overrides product.type which might be category)
        }
      ]);
    }
  };

  const removeFromCart = (productId) => {
    const updatedCart = cart.filter((item) => item.productId !== productId); // ✅ correct key
    setCart(updatedCart);
  };


  // Increase product quantity
  // Increase product quantity
  const increaseQuantity = (productId) => {
    const updatedCart = cart.map((item) =>
      item.productId === productId // Match using productId
        ? { ...item, quantity: item.quantity + 1 } // Increase the quantity of the matched product
        : item
    );
    setCart(updatedCart);
  };

  // Decrease product quantity
  const decreaseQuantity = (productId) => {
    const updatedCart = cart.map((item) =>
      item.productId === productId // Match using productId
        ? { ...item, quantity: item.quantity > 1 ? item.quantity - 1 : 1 } // Decrease quantity, ensuring it never goes below 1
        : item
    );
    setCart(updatedCart);
  };


  // Update product quantity directly
  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
      return;
    }

    const updatedCart = cart.map((item) =>
      item.id === productId ? { ...item, quantity: newQuantity } : item
    );
    setCart(updatedCart);
  };

  // Clear the cart
  const clearCart = () => {
    setCart([]);
  };

  // Calculate total price
  const totalPrice = cart.reduce((total, item) => {
    const price = item.price || 0;
    const quantity = item.quantity || 1;
    return total + price * quantity;
  }, 0);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        increaseQuantity,
        decreaseQuantity,
        updateQuantity,
        clearCart,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
export const useCart = () => useContext(CartContext);




